<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['locale'])
  }
}
</script>
<template>
  <v-row class="primary tile justify-center align-center" dense>
    <v-col
      cols="12"
      class="fill-height d-flex flex-column justify-center align-center" >
      <v-card flat tile color="transparent" dark>
        <v-card-title class="justify-center pb-6">
          <h1 class="white--text">
            {{ $t('component.dashboard.headTile.title') }}
          </h1>
        </v-card-title>
        <v-card-title class="text-center pa-6">
          <h2 class="white--text wordBreak">
            {{ $t('component.dashboard.headTile.subtitle') }}
          </h2>
        </v-card-title>
        <v-card-actions class="justify-center pt-8">
          <v-btn
            id="nowButton"
            :to="{ name: 'upload', params: { locale: locale } }"
            class="tam-yellow-btn">
            {{ $t('button.create.new.order') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
